import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedin, faGithub, faInstagram, faXTwitter } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope, faArrowUp } from '@fortawesome/free-solid-svg-icons';
import { identity } from '../data/content';

const Footer = () => (
  <footer className="border-t border-border py-10">
    <div className="container flex flex-col items-center gap-4">
      <div className="flex items-center gap-4 text-muted">
        <a href={identity.social.linkedin} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="transition-colors hover:text-primary-light">
          <FontAwesomeIcon icon={faLinkedin} />
        </a>
        <a href={identity.social.github} target="_blank" rel="noopener noreferrer" aria-label="GitHub" className="transition-colors hover:text-primary-light">
          <FontAwesomeIcon icon={faGithub} />
        </a>
        <a href={`mailto:${identity.email}`} aria-label="Email" className="transition-colors hover:text-primary-light">
          <FontAwesomeIcon icon={faEnvelope} />
        </a>
        <a href={identity.social.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="transition-colors hover:text-primary-light">
          <FontAwesomeIcon icon={faInstagram} />
        </a>
        <a href={identity.social.twitter} target="_blank" rel="noopener noreferrer" aria-label="X (Twitter)" className="transition-colors hover:text-primary-light">
          <FontAwesomeIcon icon={faXTwitter} />
        </a>
        <span className="mx-1 h-4 w-px bg-border-strong" />
        <a
          href="#top"
          aria-label="Back to top"
          className="flex h-8 w-8 items-center justify-center rounded-full border border-border-strong transition-colors hover:border-primary-light hover:text-primary-light"
        >
          <FontAwesomeIcon icon={faArrowUp} className="text-xs" />
        </a>
      </div>
      <p className="text-xs text-faint">
        Designed and developed by {identity.name} {new Date().getFullYear()}
      </p>
    </div>
  </footer>
);

export default Footer;
